import { FC } from 'react';
import style from './style.module.scss';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
interface IDateViewProps {
  dateCreate: string;
}

export const DateView: FC<IDateViewProps> = ({ dateCreate }) => {
  return (
    <p className={style.time}>
      {/* <span>{dayjs(dateCreate).utc().local().format('HH:mm')}</span>
      <span className={style.piple}>|</span> */}
      <span>{dayjs(dateCreate).format('DD.MM')}</span>
    </p>
  );
};

